// Helper to get marker URLs - needs to be called with getAssetUrl function
const getMarkerType = (getAssetUrl) => ({
  Available: getAssetUrl('/img/google-maps/marker-enabled.svg'),
  AvailableActive: getAssetUrl('/img/google-maps/marker-selected.svg'),
  PartlyAvailable: getAssetUrl('/img/google-maps/marker-enabled.svg'),
  PartlyAvailableActive: getAssetUrl('/img/google-maps/marker-selected.svg'),
  Neutral: getAssetUrl('/img/google-maps/marker-enabled.svg'),
  NeutralActive: getAssetUrl('/img/google-maps/marker-selected.svg'),
  Start: getAssetUrl('/img/google-maps/marker-enabled.svg'),
  End: getAssetUrl('/img/google-maps/marker-selected.svg'),
});

// Cache the marker types per getAssetUrl function
let cachedMarkerType = null;
let cachedGetAssetUrl = null;

const getOrCreateMarkerType = (getAssetUrl) => {
  if (cachedGetAssetUrl !== getAssetUrl) {
    cachedMarkerType = getMarkerType(getAssetUrl);
    cachedGetAssetUrl = getAssetUrl;
  }
  return cachedMarkerType;
};

export function getRetailerMarkerIcon(isActive, haveArticles, isStocked, getAssetUrl) {
  const markerType = getOrCreateMarkerType(getAssetUrl);
  let url;
  if (isActive) {
    if (haveArticles) {
      if (isStocked) {
        url = markerType.AvailableActive;
      } else {
        url = markerType.PartlyAvailableActive;
      }
    } else {
      url = markerType.NeutralActive;
    }
  } else if (haveArticles) {
    if (isStocked) {
      url = markerType.Available;
    } else {
      url = markerType.PartlyAvailable;
    }
  } else {
    url = markerType.Neutral;
  }
  return url;
}

export function getDirectionsMarkerIcon(type, getAssetUrl) {
  const markerType = getOrCreateMarkerType(getAssetUrl);
  switch (type) {
    case 'Start':
      return markerType.Start;
    case 'End':
      return markerType.End;
    default:
      return null;
  }
}
